import React, { useState } from "react";
import { Blog, Doctor, Home, Pages, Services, Shop } from "./Menu";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
const routes = [
  { path: "/", key: "home", label: "Home" },
  { path: "/about", key: "about", label: "About" },
  { path: "/services", key: "services", label: "Services" },
  { path: "/equipments", key: "equipments", label: "Equipments" },
  { path: "/doctor", key: "doctor", label: "Doctors" },
  { path: "/blog", key: "blogs", label: "Blogs" },
  { path: "/contact", key: "contact", label: "Contact" },
];

const MobileMenu = ({ mobileTrigger, setMobileTrigger, isMobile }) => {
  const [activeMenu, setActiveMenu] = useState("");
  const activeMenuSet = (value) =>
    setActiveMenu(activeMenu === value ? "" : value);
  const activeLi = (value) =>
    value === activeMenu ? { display: "block" } : { display: "none" };
  const { t } = useTranslation();
  const location = useLocation();
  const isActiveRoute = (route) => location.pathname.includes(route);

  const logoStyles = {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#333",
    textAlign: "center",
  };

  const hospitalNameStyles = {
    fontWeight: "normal",
    fontSize: "1.2rem",
    color: "#333",
    marginLeft: "0",
    textAlign: "center",
  };

  const linkStyles = (route) => {
    const isActive = location.pathname === route;
    return {
      backgroundColor: isActive ? "var(--color-fourth)" : "transparent",
      color: isActive ? "white" : "black",
      padding: "10px 20px",
      borderRadius: "5px",
      textDecoration: "none",
      fontWeight: isActive ? "bold" : "normal",
    };
  };
  const renderSubMenu = (routeKey) => {
    switch (routeKey) {
      case "doctor":
        return (
          <ul className="sub-menu" style={activeLi("Doctor")}>
            <Doctor />
          </ul>
        );
      case "blogs":
        return (
          <ul className="sub-menu" style={activeLi("Blogs")}>
            <Blog />
          </ul>
        );
      case "contact":
        return (
          <ul className="sub-menu" style={activeLi("contact")}>
            <Shop />
          </ul>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={`slide-panel mobile-slide-panel ${
        mobileTrigger ? "show-panel" : ""
      }`}
    >
      <div className="panel-overlay" onClick={() => setMobileTrigger()} />
      <div className="panel-inner">
        <div className="panel-logo">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <span style={logoStyles}>{t("home.name")}</span>
            <span style={hospitalNameStyles}>{t("home.hospital")}</span>
          </div>
        </div>

        <nav className="mobile-menu">
          <ul className="primary-menu">
            {routes.map(({ path, key, label }) => (
              <li key={key}>
                <Link to={path} style={linkStyles(path)}>
                  {t(`header.routes.${key}`)} {/* Translate the menu item */}
                </Link>
                {renderSubMenu(key)}
              </li>
            ))}
          </ul>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <LanguageSwitcher isMobile={isMobile} />
          </div>
        </nav>

        <a href="#" className="panel-close" onClick={() => setMobileTrigger()}>
          <i className="fal fa-times" />
        </a>
      </div>
    </div>
  );
};

export default MobileMenu;
